import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {LoadingBar} from "../../../components/Loader";
import Pagination from "../../../components/Pagination";

import Aqp from "../../../../libs/mk-react-aqp";
import createLink from "../../../../libs/createLink";
import {fetchStories, resetStories} from "../../../../creators/stories";
import {fetchStoriesTag, resetStoriesTag} from "../../../../creators/stories.tag";
import ArticleGrid from "../../../components/ArticleGrid";
import {Button} from "../../../components/Button";
import Helmet from "react-helmet";
import {canonical} from "../../../../libs/helper";


class Stories extends React.Component {
    constructor(props) {
        super(props);
        this.props.resetStoriesTag();
        this.props.resetStories();
        this.filter = {
            limit: (this.props.slugUser && !this.props.showAll) ? 15 : 30,
            sort: 0,
            page: 1,
            // kind: "Article",
            tags : this.props.tag._id
        };
        if(this.props.slugUser && !this.props.showAll){
            this.filter = {
                ...this.filter,
                "owner.slug!" : this.props.slugUser
            }
        }
        if(this.props.slugUser && this.props.showAll){
            this.filter = {
                ...this.filter,
                "owner.slug" : this.props.slugUser
            }
        }
        this.aqp = new Aqp({}, {
            blacklist: ['limit', 'page'],
            currentLink: createLink("tagStory", {tag : this.props.tag, slug : this.props.slugUser, showAll : this.props.showAll}),
            filterDefault: this.filter
        });
        this.state = {
            filter: {...this.filter, ...this.aqp.query, page: this.props.match.params.page || 1},
        };

        this.handleChangePage = this.handleChangePage.bind(this);
        if(this.props.slugUser && !this.props.showAll){
            this.getStoriesTag({
                ...this.state.filter,
                limit : 9,
                page : 1,
                "owner.slug" : this.props.slugUser
            });
        }
        this.getStories(this.state.filter);

    }



    getStoriesTag(filter) {
        let query = {...filter};
        this.props.fetchStoriesTag(query);
    }

    getStories(filter) {
        let query = {...filter};
        this.props.fetchStories(this.aqp.set(query));
    }

    handleChangePage(page) {
        let filter = {...this.state.filter, page};
        this.setState({filter});
        this.getStories(filter);
        window.scrollTo(0, 0);
    }

    render() {
        let totalPage = this.props.stories ? Math.ceil(this.props.storiesTotal / this.state.filter.limit) : 0;
        let url = createLink("tagStory", {tag : this.props.tag, showAll :true});
        let currentPage = parseInt(this.state.filter.page);
        return (

                <div className={"big column"}>
                    <Helmet>
                        <title>{(this.props.tag && this.props.tag.infos && this.props.tag.infos.story && this.props.tag.infos.story.title) || this.props.metaHelmet().title }</title>
                        <meta name="description" content={(this.props.tag && this.props.tag.infos && this.props.tag.infos.story && this.props.tag.infos.story.description) || this.props.metaHelmet().description } />
                        <meta name="robots" content="noindex" />
                        {currentPage === 2 && (<link rel="prev" href={canonical(url, "", "tags")}/>)}
                        {currentPage >= 3 && (<link rel="prev" href={`${canonical(`${url}/${(currentPage - 1)}`, "", "tags")}`} />)}
                        <link rel="canonical" href={currentPage >1 ? `${canonical(`${url}/${currentPage}`, "", "tags")}` : canonical(url, "", "tags")} />
                        {totalPage >0 && currentPage < totalPage && (<link rel="next" href={`${canonical(`${url}/${(currentPage + 1)}`, "", "tags")}`} />)}
                    </Helmet>
                    {this.props.storiesLoading && (
                        <LoadingBar />
                    )}
                    {this.props.storiesTagTotal !== 0 && this.props.slugUser && (
                        <h3 className={"w-100 flex-jc-sb"}>
                            Contenu de : {this.props.storiesTag && this.props.storiesTag[0] && this.props.storiesTag[0].owner && this.props.storiesTag[0].owner.username}
                            <Button to={this.aqp.queryUrl(this.state.filter).link+"/all"}
                               className={"mr-8 primary small"}
                               size={"small"}
                               btnStyle={"primary"}
                                    content={"Voir tout"}
                            />
                        </h3>
                    )}
                    {this.props.storiesTagInitialized && !this.props.storiesTagLoading && (
                        this.props.storiesTagTotal > 0 ? (
                            <ArticleGrid handleUserId={this.handleUserId}
                                         isStory={true}
                                         articles={this.props.storiesTag}
                                         userStories={false}
                                         removeHtml={true}/>
                        ) : (
                            <div className={"no-content"}>Aucune histoire correspondante à votre recherche</div>
                        ))
                    }

                    {this.props.storiesTagTotal !== 0 && this.props.slugUser && (
                        <h4 className={"w-100 mt-24"}>Découvrez d'autres histoires de Voissanautes avec le tag "{this.props.tag && this.props.tag.title}"</h4>
                    )}
                    {this.props.storiesInitialized && !this.props.storiesLoading && (
                    this.props.storiesTotal > 0 ? (
                        <ArticleGrid handleUserId={this.handleUserId}
                                     isStory={true}
                                     articles={this.props.stories}
                                     userStories={false}
                                     removeHtml={true}/>
                    ) : (
                        this.props.storiesTagTotal !== 0 && (<div className={"no-content"}>Aucune histoire correspondante à votre recherche</div>)
                    )
                    )}

                    {totalPage > 1 && (
                        <Pagination
                            currentPage={this.state.filter.page}
                            pagesCount={totalPage}
                            {...this.aqp.queryUrl(this.state.filter)}
                            handleChangePage={this.handleChangePage}
                        />
                    )}
                </div>

        )
    }
}


const mapStateToProps = (state) => {
    return {
        stories: state.stories.data,
        storiesLoading: state.stories.loading,
        storiesInitialized: state.stories.initialized,
        storiesTotal: state.stories.total,

        storiesTag: state.storiesTag.data,
        storiesTagLoading: state.storiesTag.loading,
        storiesTagInitialized: state.storiesTag.initialized,
        storiesTagTotal: state.storiesTag.total,


    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchStories,
    fetchStoriesTag,
    resetStories,
    resetStoriesTag
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(Stories);
